import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';

class AccessPermissionsRepository extends HttpRepository {
    private static readonly RESOURCE = 'access-permissions';

    /**
     * Obtiene el listado de Permisos de Acceso al DC de acuerdo a los parámetros enviados
     * @param customerId id del cliente que inicia sesión
     * @param limit cantidad de Permisos de Acceso al DC a listar
     * @param start número por el cual se empiezan a listar los Permisos de Acceso al Datacenter
     */
    getAccessPermissions(
        customerId?: number,
        limit: number = 10,
        start: number = 1,
        dataCenterId?: number,
        statusId?: number,
        keyword?: string,
        emergencyAccess?: boolean,
    ) {
        return this.get(
            this.createUri([`${AccessPermissionsRepository.RESOURCE}`], {
                customerId,
                limit,
                start,
                dataCenterId,
                statusId,
                keyword,
                emergencyAccess,
            }),
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Crea una acción (aprobar, rechazar o solicitar cambios) como parte del flujo de aprobación
     * @param action acción que se va a ejecutar al Permiso de Trabajo como parte del flujo de aprobación
     */
    createActionOverAccessPermission(action) {
        // TODO: Definir una interfaz para esto
        return this.post(
            this.createUri([`${AccessPermissionsRepository.RESOURCE}`, 'review']),
            action,
            this.createAuthorizationHeader(),
        );
    }
}

export default new AccessPermissionsRepository();
